import React, { useEffect, useRef } from 'react';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';

/**
 * Emoji picker for web using emoji-mart.
 *
 * @param {function} onSelect
 * @param {string} searchTerm
 */
const EmojiPicker = ({ onSelect, searchTerm, ...props }) => {
  const containerRef = useRef(null);

  const handleEmojiSelect = (emoji) => {
    if (onSelect) {
      onSelect(emoji.native);
    }
  };

  useEffect(() => {
    if (!searchTerm || !containerRef.current) return;

    const timer = setTimeout(() => {
      const picker = containerRef.current?.querySelector('em-emoji-picker');
      if (picker?.shadowRoot) {
        const searchInput = picker.shadowRoot.querySelector('input[type="search"]');
        if (searchInput) {
          searchInput.value = searchTerm;
          searchInput.dispatchEvent(new Event('input', { bubbles: true }));

          const originalTransition = searchInput.style.transition;
          const originalBoxShadow = searchInput.style.boxShadow;
          const glowOn = '0 0 0 3px rgba(161, 93, 54, 0.4)'; // Sienna glow
          const glowOff = originalBoxShadow || 'none';

          searchInput.style.transition = 'box-shadow 0.3s ease-out';

          searchInput.style.boxShadow = glowOn;
          setTimeout(() => {
            searchInput.style.boxShadow = glowOff;
          }, 400);

          setTimeout(() => {
            searchInput.style.boxShadow = glowOn;
          }, 700);

          setTimeout(() => {
            searchInput.style.boxShadow = glowOff;
            setTimeout(() => {
              searchInput.style.transition = originalTransition;
            }, 300);
          }, 1400);
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  return (
    <div ref={containerRef}>
      <Picker
        data={data}
        onEmojiSelect={handleEmojiSelect}
        theme="light"
        set="native"
        previewPosition="none"
        skinTonePosition="none"
        maxFrequentRows={2}
        perLine={12}
        {...props}
      />
    </div>
  );
};

export default EmojiPicker;
